import { useState, useEffect } from 'react';

export function useTimeElapsed(timestampMs: number | null | undefined): string | null {
  const [elapsed, setElapsed] = useState<string | null>(null);

  useEffect(() => {
    if (!timestampMs) {
      setElapsed(null);
      return;
    }

    const calculateElapsed = () => {
      const now = Date.now();
      const diffMs = Math.max(0, now - timestampMs);
      const diffMins = Math.floor(diffMs / 60000);
      
      if (diffMins < 1) {
        return '< 1m';
      }
      if (diffMins >= 60) {
        const hours = Math.floor(diffMins / 60);
        const mins = diffMins % 60;
        return `${hours}h ${mins}m`;
      }
      return `${diffMins}m`;
    };

    setElapsed(calculateElapsed());

    // Update every minute
    const interval = setInterval(() => {
      setElapsed(calculateElapsed());
    }, 60000);

    return () => clearInterval(interval);
  }, [timestampMs]);

  return elapsed;
}
